import { Injectable } from '@angular/core';
import { MachineCounterStore } from './machine-counter.store';
import { WorkCenterCounter } from 'chronos-core-client';

@Injectable({ providedIn: 'root' })
export class MachineCounterService {
  constructor(private machineCounterStore: MachineCounterStore) {}

  public updateMachineCounter(machineCounter: Partial<WorkCenterCounter>): void {
    this.machineCounterStore.update({ ...machineCounter });
  }
}
